import { api } from 'services/api';
import { Company } from 'types/company';
import { Vacancy } from 'types/vacancy';
import { formatTextRich } from 'utils/format';
import { buildGoogleForJobsData } from 'utils/vacancy';
import { Layout } from 'components/templates';
import { VacancyDetails } from 'components/molecules';
import { GetStaticProps } from 'next';
import useStore from 'store';
import { useEffect } from 'react';

export interface VacancyProps {
  company: Company;
  vacancy: Vacancy;
  redirect: boolean;
}

const VacancyPage = ({ company, vacancy }: VacancyProps) => {
  const { setCompany } = useStore(state => state.company);

  useEffect(() => {
    setCompany(company);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company]);

  const description = formatTextRich(vacancy.description);

  return (
    <Layout vacancy={vacancy}>
      <VacancyDetails {...vacancy} formattedDescription={description} />
    </Layout>
  );
};

export async function getStaticPaths() {
  try {
    const { data: response } = await api.get(`/home/vacancy?take=1`);
    const ids = [response.data.data[0].id];

    const paths = ids.map(id => ({
      params: { id: id.toString() },
    }));

    return { paths, fallback: 'blocking' };
  } catch (error) {
    return {
      paths: [],
      fallback: 'blocking',
    };
  }
}

export const getStaticProps: GetStaticProps = async context => {
  const id = context.params.id;
  let company;

  try {
    const { data: vacancy } = await api.get(`/home/vacancy/${id}`);

    if (vacancy?.slug && !vacancy.isHiddenJob) {
      company = await api.get(`/home/company/${vacancy?.slug}`);
    }

    return {
      props: {
        company: {
          slug: vacancy.isHiddenJob ? null : vacancy.slug,
          logo: company?.data?.config_logo || company?.data?.logo,
        },
        vacancy,
        googleForJobsData: buildGoogleForJobsData(vacancy),
      },
      revalidate: 60 * 15,
    };
  } catch (err) {
    return {
      notFound: true,
    };
  }
};

export default VacancyPage;
